import { AddOutlined, DeleteOutline } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { Button } from "src/components/Form";
import { FC } from "react";
import { ProductCategoryResponse } from "src/models/product/ProductCategoryResponse";

type ProductCategoryRowProps = {
  productCategory: ProductCategoryResponse;
  isAdded: boolean;
  onClick: (product: ProductCategoryResponse) => void;
};

export const ProductCategoryRow: FC<ProductCategoryRowProps> = ({ productCategory, isAdded, onClick }: ProductCategoryRowProps) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      padding={2}
      borderBottom={1}
      borderColor={(theme) => theme.palette.grey[400]}
      width="100%"
    >
      <div style={{ flexGrow: 1 }}>
        <div>
          <strong>{productCategory.name}</strong>
        </div>
        <div>ID: {productCategory.id}</div>
      </div>
      {isAdded ? (
        <Button type="iconOnly" onClick={() => onClick(productCategory)}>
          <DeleteOutline />
        </Button>
      ) : (
        <Button type="iconOnly" icon={<AddOutlined />} onClick={() => onClick(productCategory)} />
      )}
    </Stack>
  );
};
